export default "__VITE_ASSET__O3TucvQW__"